<template>
  <div>
    <div class="row border-bottom white-bg dashboard-header">
      <div class="col-lg-2">
        <el-tooltip class="item" effect="dark" content="Back" placement="bottom">
          <i class="el-icon-back" @click="handleBack" style="font-size: 4rem; padding: 3px; cursor: pointer"></i>
        </el-tooltip>
      </div>
      <div class="col-lg-8">
        <h2 style="text-align: center">Survey Builder</h2>
      </div>
    </div>
    <el-tabs v-model="tabActive">
      <el-tab-pane label="Setup" name="setup">
        <setup-tab></setup-tab>
      </el-tab-pane>

      <el-tab-pane label="Canvas" name="canvas" :disabled="!survey.id">
        <canvas-tab></canvas-tab>
      </el-tab-pane>
      <el-tab-pane label="Preview & Publish" name="preview" :disabled="!survey.id">
        <preview-tab ref="previewTab"></preview-tab>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import * as surveyBuilderTypes from '@/store/modules/surveybuilder/mutation-types';

import CanvasTab from './tabs/CanvasTab';
import SetupTab from './tabs/SetupTab';
import PreviewTab from './tabs/PreviewTab';

export default {
  name: 'SurveyBuilderEditor',
  components: {
    CanvasTab,
    SetupTab,
    PreviewTab,
  },
  computed: {
    ...mapState('surveybuilder', ['survey']),

    tabActive: {
      get() {
        return this.$store.state.surveybuilder.tabActive;
      },
      set(tab) {
        if (tab === 'preview') {
          this.$refs.previewTab.reloadPreview();
        }

        this.$store.commit(`surveybuilder/${surveyBuilderTypes.SET_TAB_ACTIVE}`, tab);
      },
    },
  },
  created() {
    const surveyId = this.$route.params.id || null;

    this.$store.commit(`surveybuilder/${surveyBuilderTypes.RESET_SURVEYBUILDER}`);

    if (surveyId) {
      this.$store.dispatch('surveybuilder/getSurvey', parseInt(surveyId, 10));
    }

    this.$store.dispatch('surveybuilder/getQuestionCategories');
    this.$store.dispatch('surveybuilder/getQuestionCategoriesWithQuestions');
    this.$store.dispatch('surveybuilder/getChoiceCategories');
    this.$store.dispatch('surveybuilder/getQuestions');
    this.$store.dispatch('surveybuilder/getChoiceTemplates');
    this.$store.dispatch('surveybuilder/getChoices');

    this.$store.dispatch('surveybuilder/getHooks');
    this.$store.dispatch('surveybuilder/getMatrixChoices');
  },
  methods: {
    handleBack() {
      this.$router.push({ path: '/surveyBuilder' });
    },
  },
};
</script>



// WEBPACK FOOTER //
// SurveyBuilderEditor.vue?1cb6bfda